import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Checkbox from 'crehana-ui/Checkbox';
import Text from 'crehana-ui/Text';

import { toggleFilterSoftware } from '../../../redux/actions';

import { ItemWrapper } from '../styles';

type SoftwaresItem = {
  id: number;
  name: string;
  disabled: boolean;
  original_image_url: string;
};

type Props = {
  softwares: {
    id: string;
    name: string;
    subItems: {
      [key: string]: SoftwaresItem;
    };
  };
  toggleFilterSoftware(params: { subItemId: number }): void;
  softwaresSelected: {
    [key: number]: SoftwaresItem;
  };
};

const ImageWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 8px;
  & > img {
    width: 100%;
  }
`;

class Softwares extends React.Component<Props> {
  onClickSoftware = ({ software }: { software: SoftwaresItem }) => () => {
    this.props.toggleFilterSoftware({ subItemId: software.id });
  };

  render() {
    const { softwares, softwaresSelected } = this.props;

    const softwaresArray = Object.keys(softwares.subItems).map(
      subItem => softwares.subItems[subItem],
    );

    return softwaresArray.map(software => {
      const isSelected = !!softwaresSelected[software.id];

      return (
        <ItemWrapper
          key={software.id}
          style={{ opacity: software.disabled ? 0.3 : 1 }}
          onClick={
            software.disabled ? null : this.onClickSoftware({ software })
          }
        >
          <div className="flex items-center">
            <ImageWrapper>
              <img src={software.original_image_url} alt="" />
            </ImageWrapper>
            <Text type="body2">{software.name}</Text>
          </div>
          <Checkbox
            checked={isSelected}
            error={false}
            wrapperProps={{
              onClick: e => {
                e.preventDefault();
              },
            }}
          />
        </ItemWrapper>
      );
    });
  }
}

const mapStateToProps = state => ({
  softwares: state.filters.softwares,
  softwaresSelected: state.filters.softwaresSelected,
});

export default connect(
  mapStateToProps,
  { toggleFilterSoftware },
)(Softwares);
